export const getCorCertificadoPorDias = (dias: number) => {
  if (dias > 0) return '#ff006e'
  if (dias >= -7) return '#BF1A2F'
  if (dias >= -15) return '#FFBE0B'

  return '#018E42'
}